import Vue from 'vue'
import VueRouter from 'vue-router'
import CustomerPage from '../vue/pages/Customer.vue'

export default {
  init() {
    const routes = [
      { path: '/', redirect: '/all' },
      { path: '/all', name: 'all', component: CustomerPage },
      { path: '/:slug', name: 'cat', component: CustomerPage },
    ]
    const router = new VueRouter({
      // mode: 'history',
      routes,
    })
    new Vue({
      el: '.main-content',
      router,
    })
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
}
